import { request } from "@/utils/http";


export default {
    firmwareList: (params = {}) => request.get('/firmware-list', { params }),
    productDetail: (params = {}) => request.get('/product-models', { params }),
    addUpgradeRecords: (data) => request.post('/upgrade-records', data),
    pluginVersion: () => request.get('/plugins/last'),
    hardwareProtocol: () => request.get('/hardware-protocol'),
    addConnectRecord: (data) => request.post('/connect-record',data),
    productNotify: (data) => request.post('/product-notify',data),
    // 新增接口：获取用户升级次数信息
    getUserUpgradeInfo: (params = {}) => request.get('/user-upgrade-info', { params }),
    // 新增接口：更新用户升级次数
    updateUserUpgradeCount: (data) => request.post('/user-upgrade-count', data),
    // 新增接口：申请升级次数
    applyUpgradeCount: (data) => request.post('/apply-upgrade-count', data),
    // 新增接口：更新用户信息（包含diff_upgrade_count）
    updateUserInfo: (data) => request.post('/update-user-diff-upgrade-count', data),
    // P8组织用户升级文件查找接口 - 使用/auto-upgrades接口
    getP8UpgradeFiles: (serialNumber) => request.get('/auto-upgrades', { params: { 'devices-serial_no-eq': serialNumber } }),
    // 检查最新固件接口
    checkLatestFirmware: (params = {}) => request.get('firmware-versions', { params }),
}